export const manifestApi = {
    /****************************************************************************
     * 
     * Manifests
     * 
     ***************************************************************************/

    /**
     * Fetch Agent Manifest
     * @returns {Promise} - The Agent Manifest as a Promise
     */
    fetchAgentManifest: async (config) => {
        const url = `${config.agentManifestUrl}?uniqifier=${Date.now()}`
        const response = await fetch(url)
        if (!response.ok) {
            let error = new Error(`Failed to fetch Agent Manifest. Status: ${response.statusText}`)
            error.code = response.status
            throw error
        }
        return await response.json().then(
            (result) => {
                return result.product
            }
        )
    },
    /**
     * Fetch UTG Manifest
     * @returns {Promise} - The UTG Manifest as a Promise
     */
    fetchUTGManifest: async (config) => {
        const url = `${config.utgManifestUrl}?uniqifier=${Date.now()}`
        const response = await fetch(url)
        if (!response.ok) {
            let error = new Error(`Failed to fetch UTG Manifest. Status: ${response.statusText}`)
            error.code = response.status
            throw error
        }
        return await response.json().then(
            (result) => {
                return result.product
            }
        )
    },
    fetchSchemaManifest: async () => {
        let response = await fetch('/schemas/schemamanifest.json')
        return await response.json()
    }
}